import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const calculateSlice = createSlice({
  name: 'ProposalOffer',
  initialState,
  reducers: {
    updateProposalOffer: (state, action) => ({ ...state, ...action.payload }),
    resetPoposal: () => initialState,
  },
});

export const { updateProposalOffer, resetlProposalOffer } = calculateSlice.actions;
export default calculateSlice.reducer;
